<!-- USed in advance searching the vault archives
component used in VaultArchive.vue
-->
<template>
  <v-row no-gutters>
    <v-col>
      <AdvanceSearchContainer
        :primaryColor="primaryColor"
        @clearAllData="cancelSearch"
        @getSearchObject="searchData"
        :searchParams="searchParams"
        :expanded="defaultState"
        :parentDataTestId="dataTestId"
      >
        <template slot="advance_search_items">
          <!-- form to be filled for search  -->
          <div>
            <!-- row 1 -->
            <v-row class="mb-1" no-gutters>
              <v-col sm="12" class="py-0">
                <span class="top-label">
                  Date
                  <span v-show="selectedRange === 0">Range</span>
                  <span v-show="selectedRange !== 0">Within</span>
                </span>
              </v-col>
            </v-row>
            <!-- row 1 input-->
            <v-row class="mb-4" align="center" no-gutters>
              <v-col
                sm="2"
                class="positionRelative"
                :data-test-id="`${dataTestId}__date-range-col`"
              >
                <v-select
                  :items="dateRanges"
                  solo
                  dense
                  flat
                  v-model="selectedRange"
                  append-icon="keyboard_arrow_down"
                  item-value="id"
                  class="cursorPointer"
                  filled
                  item-text="label"
                  height="52px"
                  :attach="`[data-test-id='${dataTestId}__date-range-col']`"
                ></v-select>
              </v-col>
              <v-col sm="1" class="justify-center align-center">
                <p class="andText mx-2 text-center mb-0">on</p>
              </v-col>
              <v-col
                class="py-0 mt-0 positionRelative"
                sm="2"
                :data-test-id="`${dataTestId}__search-range-col`"
              >
                <v-select
                  :items="searchRange"
                  solo
                  dense
                  flat
                  v-model="search"
                  append-icon="keyboard_arrow_down"
                  item-value="id"
                  class="cursorPointer"
                  filled
                  item-text="label"
                  height="52px"
                  :attach="`[data-test-id='${dataTestId}__search-range-col']`"
                ></v-select>
              </v-col>
              <v-col
                sm="2"
                class="justify-center align-center"
                v-show="selectedRange !== 0"
              >
                <p class="andText mx-2 text-center">of</p>
              </v-col>
              <v-col class="py-0 mt-0" sm="5" v-show="selectedRange !== 0">
                <DatePicker
                  :setDate="selectedDate"
                  :parentDataTestId="dataTestId"
                />
              </v-col>
            </v-row>
            <!-- row 2 -->
            <v-row class="mb-1" no-gutters>
              <v-col sm="5" class="top-label">Accessible by</v-col>
              <v-col sm="2" class="top-label"></v-col>
              <v-col sm="5" class="top-label">File Extensions</v-col>
            </v-row>
            <!-- row 2 input -->
            <v-row class="mb-4" no-gutters>
              <!-- <v-col class="py-0 mt-0" sm="2"></v-col> -->
              <v-col
                class="py-0 mt-0 positionRelative"
                sm="5"
                :data-test-id="`${dataTestId}__accessible-by-col`"
              >
                <v-autocomplete
                  v-if="usersList"
                  solo
                  flat
                  filled
                  height="52px"
                  type
                  clearable
                  v-model="ownerId"
                  :items="usersList"
                  item-text="fullName"
                  item-value="id"
                  append-icon="keyboard_arrow_down"
                  v-on:change="addOwner(ownerId)"
                  :attach="`[data-test-id='${dataTestId}__accessible-by-col']`"
                >
                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title>{{
                        data.item.fullName
                      }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        data.item.email[0]
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
                <div
                  class="list-container"
                  v-if="accessibleBy.length > 0"
                  :data-test-id="`${dataTestId}__accessible-by-tag-list`"
                >
                  <tag
                    v-for="(item, index) in accessibleBy"
                    :key="index"
                    :title="item.name"
                    :text="truncate(item.name)"
                    data-class="dynamicTagsdark"
                    :showDelete="true"
                    :data-test-id="
                      `${dataTestId}__accessible-by-tag-list-item-${index + 1}`
                    "
                    @click="deleteItem(item, accessibleBy)"
                  ></tag>
                </div>
              </v-col>
              <v-col class="py-0 mt-0" sm="2"></v-col>
              <v-col
                class="py-0 mt-0"
                sm="5"
                :data-test-id="`${dataTestId}__file-extension-col`"
              >
                <v-text-field
                  filled
                  solo
                  flat
                  class="full-width"
                  v-model="fileExtension"
                  v-on:keyup.enter="addItems(fileExtension, fileExtensions)"
                ></v-text-field>
                <div
                  class="list-container mt-0"
                  v-if="fileExtensions.length > 0"
                  :dataTestId="`${dataTestId}__file-extension-tag-list`"
                >
                  <tag
                    v-for="(item, index) in fileExtensions"
                    :key="index"
                    :title="item"
                    :text="truncate(item)"
                    data-class="dynamicTagsdark"
                    :showDelete="true"
                    :data-test-id="
                      `${dataTestId}__file-extension-tag-list-item-${index + 1}`
                    "
                    @click="deleteItem(item, fileExtensions)"
                  ></tag>
                </div>
              </v-col>
            </v-row>
            <v-row class="mb-1" no-gutters>
              <v-col sm="5" class="top-label">
                Contains Text
                <small>( you can use * as wildcard )</small>
              </v-col>
              <v-spacer />
              <v-col sm="5" class="top-label">
                Filename
                <small>( you can use * as wildcard )</small>
              </v-col>
            </v-row>
            <!-- row 3 input-->
            <v-row class="mb-4" no-gutters>
              <v-col sm="5" class="py-0 mt-0">
                <v-row class="contiansRow">
                  <v-col
                    sm="5"
                    class="py-0 positionRelative"
                    :data-test-id="`${dataTestId}__contains-options-col`"
                  >
                    <v-select
                      :items="containsOptions"
                      solo
                      dense
                      flat
                      v-model="contains"
                      append-icon="keyboard_arrow_down"
                      item-value="id"
                      class="cursorPointer"
                      filled
                      item-text="label"
                      height="56px"
                      :attach="
                        `[data-test-id='${dataTestId}__contains-options-col']`
                      "
                    ></v-select>
                  </v-col>
                  <v-col
                    sm="7"
                    class="py-0"
                    :data-test-id="`${dataTestId}__contains-text-col`"
                  >
                    <v-text-field
                      flat
                      filled
                      solo
                      v-model="searchBody"
                      v-on:keyup.enter="
                        addItems(searchBody, searchBodyItems, contains)
                      "
                    ></v-text-field>
                  </v-col>
                </v-row>
                <div
                  class="list-container"
                  v-if="searchBodyItems.length > 0"
                  :dataTestId="`${dataTestId}__contains-text-tag-list`"
                >
                  <tag
                    v-for="(item, index) in searchBodyItems"
                    :key="index"
                    :title="item"
                    :text="truncate(item)"
                    data-class="dynamicTagsdark"
                    :showDelete="true"
                    :data-test-id="
                      `${dataTestId}__contains-text-tag-list-item-${index + 1}`
                    "
                    @click="deleteItem(item, searchBodyItems)"
                  ></tag>
                </div>
              </v-col>
              <v-spacer />
              <v-col
                sm="5"
                class="py-0"
                :data-test-id="`${dataTestId}__filename-col`"
              >
                <v-text-field
                  flat
                  filled
                  solo
                  class="full-width"
                  v-model="fileName"
                  v-on:keyup.enter="addItems(fileName, fileNames)"
                ></v-text-field>
                <div
                  class="list-container mt-0"
                  v-if="fileNames.length > 0"
                  :dataTestId="`${dataTestId}__filename-tag-list`"
                >
                  <tag
                    v-for="(item, index) in fileNames"
                    :key="index"
                    :title="item"
                    :text="truncate(item)"
                    data-class="dynamicTagsdark"
                    :showDelete="true"
                    :data-test-id="
                      `${dataTestId}__filename-tag-list-item-${index + 1}`
                    "
                    @click="deleteItem(item, fileNames)"
                  ></tag>
                </div>
              </v-col>
            </v-row>

            <!-- row 5 -->
            <v-row class="mb-1" no-gutters>
              <v-col class="py-0 mt-0" sm="5">
                <v-row>
                  <v-col
                    v-if="!isSingleConnectorScreen"
                    sm="5"
                    class="top-label py-0"
                  >
                    Source Type
                  </v-col>
                  <v-col v-if="!isTeamsFilter" sm="7" class="top-label py-0"
                    >Is latest?</v-col
                  >
                </v-row>
              </v-col>
              <v-spacer />
              <v-col
                v-if="!isTeamsFilter && !isDropboxFilter"
                sm="5"
                class="mt-0 align-self-end top-label py-0"
              >
                Directory Name
              </v-col>
            </v-row>
            <v-row class="mb-4" no-gutters>
              <v-col class="py-0 mt-0" sm="5">
                <v-row class="align-center">
                  <v-col
                    v-if="!isSingleConnectorScreen"
                    sm="5"
                    class="py-0 positionRelative"
                    :data-test-id="`${dataTestId}__source-type-col`"
                  >
                    <v-select
                      :items="sourceTypes"
                      solo
                      dense
                      flat
                      v-model="sourceType"
                      placeholder="Sources"
                      append-icon="keyboard_arrow_down"
                      item-value="id"
                      class="cursorPointer"
                      filled
                      item-text="title"
                      height="52px"
                      :attach="
                        `[data-test-id='${dataTestId}__source-type-col']`
                      "
                      @change="emptySelectedFilters"
                    ></v-select>
                  </v-col>
                  <v-col
                    v-if="!isTeamsFilter"
                    sm="7"
                    class="py-0"
                    :data-test-id="`${dataTestId}__show-latest-col`"
                  >
                    <Checkbox
                      v-model="isLatest"
                      title="Show latest?"
                      theme="light"
                    ></Checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <v-spacer />
              <v-col
                v-if="!isTeamsFilter && !isDropboxFilter"
                class="py-0 mt-0"
                sm="5"
                :data-test-id="`${dataTestId}__directory-name-col`"
              >
                <v-text-field
                  filled
                  solo
                  flat
                  v-model="sourcePath"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
        </template>
      </AdvanceSearchContainer>
    </v-col>
  </v-row>
</template>

<script>
import EventBus from '@/EventBus';
import DatePicker from '@/components/Common/DatepickerRaw';
import AdvanceSearchContainer from '@/components/AdvanceSearch/AdvanceSearchContainer';
import Checkbox from '@/components/Common/Checkbox';
import { isEmptyObject, filterObjectByKeys } from '@/helpers/common';
import {
  containsOptions,
  dateRanges
} from '../AdvanceSearch/AdvanceSearchHelpers';
import { mapState } from 'vuex';
var findIndex = require('lodash.findindex');

export default {
  components: { DatePicker, Checkbox, AdvanceSearchContainer },

  data() {
    return {
      ownerId: '',
      searchParams: '',
      searchParamsText: '',
      selectedRange: 0,
      sourcePath: '',
      fromDate: '',
      sourceType: 'All',
      toDate: '',
      fromDateItems: [],
      toDateItems: [],
      sourceTypes: [],
      dateRanges: this.copyArray(dateRanges),

      date: new Date().toISOString().substr(0, 10),
      maxDate: new Date().toISOString().substr(0, 10),
      day: '',
      contains: 'MUST',
      containsOptions: this.copyArray(containsOptions),
      searchRange: [
        {
          id: 'updatedOn',
          label: 'synced at'
        },
        {
          id: 'createdOn',
          label: 'created at'
        }
      ],
      search: 'createdOn',
      allUsers: [],
      searchBody: '',
      searchBodyItems: [],
      primaryColor: '#58e2c2',
      ...this.clearItem({ all: true }),
      isLatest: true,
      dataTestId: 'vault-advance-search'
    };
  },
  props: {
    defaultState: Boolean,
    isTeamsArchive: Boolean,
    isDropboxArchive: Boolean
  },
  watch: {
    currentlySelectedOrgId: {
      handler: function() {
        this.getUsers();
      }
    },
    activeConnectors: {
      handler: function() {
        this.getSourceTypes();
      }
    },
    sourceType: {
      handler: function(newVal, oldVal) {
        // Reset isLatest to default state when user switch from SourceType Teams (to) -> any other value
        if (oldVal === 'o365_teams') {
          this.isLatest = true;
        }
      }
    },
    // Since filter chips are depending on query params of route,
    // So we need to set "searchParams" as "advanceSearchParams" changes
    advanceSearchParams: function (newVal, oldVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.displaySearchCriteria();
      }
    }
  },
  created() {
    this.getSourceTypes();
  },
  mounted() {
    this.initEvents();
    this.getData();
    this.emptySelectedFilters();
  },
  beforeDestroy() {
    EventBus.$off('getUpdatedDataOnDateChange');
    EventBus.$off('SearchDTO');
  },
  methods: {
    /**
     * To initialize events
     */
    initEvents() {
      EventBus.$on('getUpdatedDataOnDateChange', selectedDate => {
        this.selectedDate = selectedDate;
      });
    },
    /**
     * To get data on mounted
     */
    async getData() {
      try {
        await this.getUsers();
        if (!isEmptyObject(this.advanceSearchParams)) {
          this.setSearchCriteria();
        }
      } catch (err) {
        this.snackbar('error', err);
      }
    },
    // to clear all search params(more like filters)
    cancelSearch() {
      EventBus.$emit('SearchDTO', {});
      this.clearAll();
    },

    /**
     * This is similar to addItems but specially desgined to add owner to the accessibleBy array
     * It add name as well as id both to the accessibleBy list
     * @param {String} ownerId
     */
    addOwner(ownerId) {
      let list = this.allUsers;

      list = list.filter(vl => {
        return vl.id === ownerId;
      });
      if (list.length) {
        this.accessibleBy.push({
          id: list[0].id,
          name: list[0].fullName
        });
      }
    },

    getSourceTypes() {
      const activeVault = this.connectorArchiveNameMap(null, 'consentMenu');
      this.sourceTypes = [{ title: 'All', id: undefined }, ...activeVault];
    },

    // clear all the data once done
    // used in multiple places to clear all Search DTO
    clearAll() {
      const allItems = this.clearItem({ all: true });
      Object.keys(allItems).forEach(item => {
        this[item] = allItems[item];
      });
    },

    /**
     * to clear the advance search fields
     * @param {Boolean} all
     * @param {String} id
     */
    clearItem({ all, id }) {
      const items = {
        searchParams: '',
        searchBody: '',
        fileName: '',
        fileExtension: '',
        fileExtensions: [],
        containsMap: {
          MUST: [],
          SHOULD: [],
          MUST_NOT: []
        },
        selectedDate: new Date().toISOString(),
        selectedRange: 0,
        sourceType: 'All',
        search: 'createdOn',
        contains: 'MUST',
        fileNames: [],
        sourcePath: '',
        accessibleBy: [],
        isLatest: false,
        searchBodyItems: [],
        openadvanceSearch: false,
        closeIcon: false,
        searchParamsText: '',
        ownerId: ''
      };
      if (all) {
        return items;
      } else {
        return items[id];
      }
    },
    searchData(searchDataObject) {
      const removeItemId = searchDataObject.removeItem;

      if (removeItemId) {
        const isRemoveItemFromContainsOptions = this.containsOptions.find(
          ({ id }) => id === removeItemId
        );

        if (removeItemId === 'selectedRange') {
          this.selectedDate = this.clearItem({
            id: 'selectedDate'
          });
        }

        // if removeItem = 'MUST' or 'MUST_NOT' or 'SHOULD' means from containsOptions
        if (isRemoveItemFromContainsOptions) {
          this.containsMap = {
            ...this.containsMap,
            [removeItemId]: []
          };
          this.setSearchBodyItems(this.containsMap);
        } else {
          this[removeItemId] = this.clearItem({
            id: removeItemId
          });
          // Also clear ownerId along with accessibleBy clearance
          // Because when v-autocomplete re-render it will take ownerId value and show selected Item in input box
          if (removeItemId === 'accessibleBy') {
            this.ownerId = '';
          }
        }
      }

      const selectedDates = this.getSelectedDates({
        selectedDate: this.selectedDate,
        selectedRange: this.selectedRange
      });
      let data = this.getDTO(selectedDates, searchDataObject);

      EventBus.$emit('SearchDTO', data);
      this.displaySearchCriteria();
    },

    /**
     * get searched data
     * @param {Object} selectedDates
     * @param {Object} searchDataObject
     */
    getDTO(selectedDates, searchDataObject) {
      let hasWordsObj = [];
      if (
        searchDataObject.searchText.trim() !== '' &&
        !this.containsMap['MUST'].includes(searchDataObject.searchText.trim())
      ) {
        this.containsMap['MUST'] = [];
        this.containsMap['SHOULD'] = [];
        this.containsMap['MUST_NOT'] = [];
        this.searchBodyItems = [];
        this.containsMap['MUST'].push(searchDataObject.searchText.trim());
        this.searchBodyItems.push(
          searchDataObject.searchText.trim() + ' (Must)'
        );
      }
      if (this.searchBodyItems.length) {
        Object.keys(this.containsMap).forEach(key => {
          if (this.containsMap[key].length) {
            let obj = {
              containsType: key,
              hasWords: this.containsMap[key]
            };
            hasWordsObj.push(obj);
          }
        });
        if (!searchDataObject.quickSearch) {
          this.searchBody = '';
        }
      }

      if (this.fileName && !this.fileNames.includes(this.fileName.trim())) {
        this.fileNames.push(this.fileName);
        this.fileName = '';
      }
      if (
        this.fileExtension &&
        !this.fileExtensions.includes(this.fileExtension.trim())
      ) {
        this.fileExtensions.push(this.fileExtension);
        this.fileExtension = '';
      }
      let searchObject = {
        fileNames: this.fileNames,
        latestVersion: this.isLatest ? this.isLatest : undefined,
        sourceType: this.sourceType === 'All' ? undefined : this.sourceType,
        accessibleBy: this.accessibleBy.map(owner => owner.id),
        searchRange: this.search,

        fileExtension: this.fileExtensions.map(item =>
          String(item).startsWith('.') ? item : '.' + item
        ),
        sourcePath: this.sourcePath,
        hasWords: hasWordsObj,
        selectedRange: this.selectedRange,
        selectedDate: this.selectedDate
      };
      if (selectedDates['end']) {
        searchObject['to'] = parseInt(selectedDates['end']);
      }
      if (selectedDates['start']) {
        searchObject['from'] = parseInt(selectedDates['start']);
      }

      return searchObject;
    },

    /**
     * To get users list
     */
    async getUsers() {
      try {
        let users = await this.$services.user.loadUsersAll();
        users = this.parseResponse(users);
        if (users !== false) {
          this.allUsers = users[0].results;
        } else {
          this.snackbar('error', this.$message.CANT_LOAD_USERS);
        }
      } catch (err) {
        this.snackbar('error', err);
      }
    },

    /**
     * to delete tags
     * @param {String} item
     * @param {Array} arr
     */
    deleteItem(item, arr) {
      let index = findIndex(arr, el => {
        return el === item;
      });
      if (index >= 0) {
        arr.splice(index, 1);
      }
      //delete from containsMap
      let containsLabel = [];
      containsLabel['SHOULD'] = 'Should';
      containsLabel['MUST'] = 'Must';
      containsLabel['MUST_NOT'] = 'Must Not';
      for (var key in this.containsMap) {
        if (this.containsMap[key].length) {
          index = findIndex(this.containsMap[key], el => {
            return el + ' (' + containsLabel[key] + ')' === item;
          });
          if (index >= 0) {
            this.containsMap[key].splice(index, 1);
          }
        }
      }
      this.fromDate = '';
      this.toDate = '';
      this.fileName = '';
      this.ownerId = '';
      this.fileExtension = '';
    },

    /**
     * to add tags
     * @param {String} item
     * @param {Array} arr
     * @param {Boolean} contains
     */
    addItems(item, arr, contains = null) {
      if (item.trim() === '') {
        return;
      }
      let itemToSearch = item.trim();
      if (contains) {
        let containsItem = this.containsOptions.find(
          item => item.id === contains
        );
        itemToSearch += ` (${containsItem.label})`;
      }
      let index = findIndex(arr, el => {
        return el === itemToSearch;
      });
      if (index < 0) {
        if (contains) {
          this.containsMap[contains].push(item);
          let containsItem = this.containsOptions.find(
            item => item.id === contains
          );
          item += ` (${containsItem.label})`;
        }
        arr.push(item);
      }
      this.fromDate = '';
      this.toDate = '';
      this.fileName = '';
      this.ownerId = '';
      this.fileExtension = '';

      this.searchBody = '';
    },

    /**
     * search entered data
     * @param {Object} searchDataObject
     */
    searchDataEnter(searchDataObject) {
      if (
        searchDataObject.searchText.trim() !== '' &&
        !this.containsMap['MUST'].includes(searchDataObject.searchText.trim())
      ) {
        this.containsMap['MUST'].push(searchDataObject.searchText.trim());
        this.searchBodyItems.push(
          searchDataObject.searchText.trim() + ' (Must)'
        );
      }
      let date = {
        start: '',
        end: ''
      };

      let data = this.getDTO(date, true);

      EventBus.$emit('SearchDTO', data);
    },

    /**
     * to validate date
     * @param {String} item
     * @param {Array} arr
     */
    validateDate(item, arr) {
      this.addItems(item, arr);
    },
    /**
     * Mapping of userIds to get user details
     * @param {Array} userIds
     *
     * @return if getObj = true, then array of userDetails; else array of fullName
     */
    getNamesFromIds(userIds, getObj = false) {
      const result = (userIds || []).map(id => {
        const userDetail = (this.allUsers || []).find(user => user.id === id);
        const fullName = userDetail?.fullName || '';
        const userObj = {
          id,
          name: this.formatFullName(userDetail)
        };
        return getObj ? userObj : fullName;
      });
      return result;
    },
    /**
     * To set filter chips
     */
    getSearchParams() {
      let basedOn = this.searchRange.find(item => item.id === this.search)
        .label;
      if (basedOn === 'created at') {
        basedOn = basedOn + '_DEFAULT';
      }
      let params = {
        dates: this.getSelectedDates({
          selectedDate: this.selectedDate,
          selectedRange: this.selectedRange
        }),
        contains: this.containsMap,
        accessibleBy: this.accessibleBy.map(item => item.name),
        fileExtension: this.fileExtensions,
        fileNames: this.fileNames,
        sourcePath: this.sourcePath,
        sourceType: this.getSourceType(this.sourceType),
        isLatest: this.isLatest,
        basedOn
      };
      if (!isEmptyObject(this.advanceSearchParams)) {
        const accessibleBy = this.getNamesFromIds(
          this.advanceSearchParams?.accessibleBy
        );
        const advanceSearchParams = {
          ...this.advanceSearchParams,
          sourceType: this.getSourceType(
            this.advanceSearchParams?.sourceType || 'All'
          ),
          accessibleBy
        };
        params = {
          ...params,
          ...advanceSearchParams
        };
      }
      return this.filterParamsForOrgVaultScreen(params);
    },
    /**
     * if the screen is not organization vault then
     * return rest params after filtering sourceType from searchParams,
     * so that sourceType dosn't render in filtered chips
     *
     * @param {Object} params
     */
    filterParamsForOrgVaultScreen(params) {
      // Delete version search chip for teams archives
      if (this.isTeamsFilter) {
        delete params.isLatest;
      }
      if (this.isSingleConnectorScreen) {
        const notAllowedKeys = ['sourceType'];
        return filterObjectByKeys(params, notAllowedKeys);
      }
      return params;
    },
    // to set the "searchParams" variable to display what is being searched
    displaySearchCriteria() {
      this.searchParams = this.getSearchParams();
    },
    /**
     * To get array of words under @searchParams (advanceSearchParams) of required @containsType
     */
    getWords(searchParams, containsType) {
      if (!searchParams['hasWords']) {
        return [];
      }
      const filtered = searchParams['hasWords'].filter(
        param => param.containsType === containsType
      );
      if (filtered.length) {
        return filtered[0]['hasWords'];
      }
      return [];
    },
    // Format the search params specifically for contains text
    formatContainsSearchParams(items, containsItem) {
      return items.map(item => `${item}(${containsItem})`);
    },
    /**
     * called on mounted
     * Doing 2 things :-
     * 1. setting filter chips
     * 2. setting advance search input fields
     */
    setSearchCriteria() {
      if (!isEmptyObject(this.advanceSearchParams)) {
        const sourceType = this.advanceSearchParams?.sourceType || 'All';
        const basedOn = this.searchRange.find(
          item =>
            item.id === (this.advanceSearchParams?.searchRange || 'createdOn')
        );
        const searchParams = {
          dates: {
            start: this.advanceSearchParams?.['from'] || '',
            end: this.advanceSearchParams?.['to'] || ''
          },
          contains: {
            MUST: this.getWords(this.advanceSearchParams, 'MUST'),
            SHOULD: this.getWords(this.advanceSearchParams, 'SHOULD'),
            MUST_NOT: this.getWords(this.advanceSearchParams, 'MUST_NOT')
          },
          accessibleBy: this.getNamesFromIds(
            this.advanceSearchParams?.accessibleBy
          ),
          fileExtension: this.advanceSearchParams?.fileExtension || [],
          fileNames: this.advanceSearchParams?.fileNames || [],
          sourcePath: this.advanceSearchParams?.sourcePath || '',
          sourceType: this.getSourceType(sourceType),
          isLatest: this.advanceSearchParams?.latestVersion || false,
          basedOn: basedOn.label
        };
        // Delete version search chip for teams archives
        if (sourceType === this.$enums.O365_CONNECTORS.teams.connectorId) {
          delete searchParams.isLatest;
        }
        this.searchParams = this.filterParamsForOrgVaultScreen(searchParams);
        this.fileExtensions = searchParams.fileExtension;
        this.fileNames = searchParams.fileNames;
        this.accessibleBy = this.getNamesFromIds(
          this.advanceSearchParams?.accessibleBy,
          true
        );
        this.sourceType = sourceType;
        this.isLatest = searchParams.isLatest;
        this.sourcePath = searchParams.sourcePath;
        this.search = basedOn.id;
        this.setSearchBodyItems(this.advanceSearchParams, true);
        this.containsMap = {
          MUST: this.getWords(this.advanceSearchParams, 'MUST'),
          SHOULD: this.getWords(this.advanceSearchParams, 'SHOULD'),
          MUST_NOT: this.getWords(this.advanceSearchParams, 'MUST_NOT')
        };
        this.selectedRange = this.advanceSearchParams?.selectedRange || 0;
        this.selectedDate =
          this.advanceSearchParams?.selectedDate || new Date().toISOString();
      } else {
        this.searchParams = {};
      }
    },
    /**
     * searchBodyItems are different from others
     * It contains three type of values of containsText - MUST, SHOULD & MUST_NOT
     * We get the values of specific containsText from getWords
     * We mapped values and form a string Array from formatContainsSearchParams
     * We spread those values insearchBodyItems
     *
     * @param {Boolean} fromRoute , if containsMap from route query param
     */
    setSearchBodyItems(containsMap, fromRoute) {
      this.searchBodyItems = [
        ...this.formatContainsSearchParams(
          fromRoute
            ? this.getWords(containsMap, 'MUST')
            : containsMap?.['MUST'] || [],
          'Must'
        ),
        ...this.formatContainsSearchParams(
          fromRoute
            ? this.getWords(containsMap, 'SHOULD')
            : containsMap?.['SHOULD'] || [],
          'Should'
        ),
        ...this.formatContainsSearchParams(
          fromRoute
            ? this.getWords(containsMap, 'MUST_NOT')
            : containsMap?.['MUST_NOT'] || [],
          'Must Not'
        )
      ];
    },
    /**
     * Function to get sourceType title
     * if input sourceType = 'o365_sharepoint'
     * expected output = 'Share Point'
     */
    getSourceType(sourceType) {
      return sourceType === 'All'
        ? 'All_DEFAULT'
        : this.connectorArchiveNameMap(sourceType).title;
    },
    /**
     * To remove filters not relevant for teams archives
     */
    emptySelectedFilters() {
      if (this.isTeamsFilter) {
        this.sourcePath = '';
        this.isLatest = false;
      }
      if (this.isDropboxFilter) {
        this.sourcePath = '';
      }
    }
  },

  computed: {
    ...mapState(['currentlySelectedOrgId', 'activeConnectors']),
    usersList() {
      let list = this.allUsers;
      this.accessibleBy.forEach(item => {
        list = list.filter(vl => {
          return vl.id !== item.id;
        });
      });
      return this.formatuserListForFullName(list);
    },

    /**
     * To check is screen is of single vault
     * means if screen is "organization vault" under vault, connectorType = undefined
     * then, isSingleConnectorScreen returns falsy value
     */
    isSingleConnectorScreen() {
      return this.$route.params?.connectorType || '';
    },

    advanceSearchParams() {
      const params = this.$route.query?.advanceSearchParams || '{}';
      return JSON.parse(params) || {};
    },
    isSourceTypeTeams() {
      return this.sourceType === 'o365_teams';
    },
    isTeamsFilter() {
      return this.isTeamsArchive || this.isSourceTypeTeams;
    },
    isDropboxFilter() {
      // Adding sourceType check for dropbox directly as there are no multiple case for now
      return this.isDropboxArchive || this.sourceType === 'dropbox';
    }
  }
};
</script>
